import { Toaster as Sonner, type ToasterProps } from 'sonner'
import { useTheme } from '@/providers/theme-provider'

/** Toaster global; segue o tema do app. */
export function Toaster(props: ToasterProps) {
  const { resolvedTheme } = useTheme()
  return (
    <Sonner
      theme={resolvedTheme}
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'glass !rounded-2xl',
        },
      }}
      {...props}
    />
  )
}
